import { formatMonthDayForDisplay } from "util/dates";

type AgencyDueDateFields = {
  dueDate?: string | null;
  dueDateIsAnniversary?: boolean | null;
};

export function formatAgencyDueDate(agency?: AgencyDueDateFields | null): string | null {
  if (!agency) {
    return null;
  }
  if (agency.dueDateIsAnniversary) {
    return "Anniversary of first submission";
  }
  if (agency.dueDate) {
    return formatMonthDayForDisplay(agency.dueDate);
  }
  return null;
}
